import { type DaperNewsletter, DaperStoryType } from "@bloomberg/intercom";

import { MOCK_HYDRATED_IMAGE } from "~components/shared/media";
import type { Newsletter, NewsletterImage } from "~types/types";

export const DEFAULT_HYDRATED_NEWSLETTER: Newsletter = {
    __typename: "Newsletter",
    __modelType: "Newsletter",
};

export const mockHydratedNewsletterCampaign = ({
    title,
    images,
}: {
    title?: string;
    images?: NewsletterImage[];
}): Newsletter => {
    return {
        ...DEFAULT_HYDRATED_NEWSLETTER,
        images,
        title,
    };
};

export const mockHydratedNewsletterImage = ({
    alt,
    baseUrl,
    placement,
}: {
    alt?: string;
    baseUrl?: string;
    placement?: string[];
} = {}): NewsletterImage => {
    return {
        ...MOCK_HYDRATED_IMAGE,
        alt,
        baseUrl,
        caption: "Image Caption",
        credit: "Credits for the image",
        id: "image-id",
        height: 100,
        width: 100,
        placement,
        title: "Image Title",
    };
};

// signUpLists
const NEWSLETTER_LIST = [
    { title: "Bloomberg Pursuits", signUpList: "Pursuits Weekly" },
    { title: "Tech In Brief", signUpList: "tech-in-brief" },
    { title: "Markets Daily", signUpList: "markets-daily" },
    { title: "Q&AI", signUpList: "q&ai" },
    { title: "Business of Space", signUpList: "business-of-space" },
];

export const DEFAULT_DAPER_NEWSLETTER: DaperNewsletter = {
    id: DaperStoryType.newsletter_campaign,
    type: "",
    links: {
        self: "",
    },
    attributes: {
        title: "",
        slug: "",
        description: "",
        active: false,
        sampleUrl: "/",
        signUpList: "",
        signUpListId: "",
        language: "",
        fromEmail: "",
        fromEmailName: "",
        images: [
            {
                id: "",
                target: "",
                placement: "",
            },
        ],
        tags: [
            {
                id: "",
                label: "",
                type: "",
            },
        ],
        subscriptionType: "",
    },
};

export const mockDaperNewsletter = ({
    title,
    signUpList,
    subscriptionType = "",
}: {
    title: string;
    signUpList: string;
    subscriptionType?: string;
}): DaperNewsletter => ({
    ...DEFAULT_DAPER_NEWSLETTER,
    attributes: {
        ...DEFAULT_DAPER_NEWSLETTER.attributes,
        title,
        slug: signUpList.toLowerCase().split(" ").join("-"),
        signUpList,
        subscriptionType,
    },
});

export const mockDaperNewsletters = (): DaperNewsletter[] =>
    NEWSLETTER_LIST.map(mockDaperNewsletter);
